import LoginSocials from './LoginSocials'
import LoginSocialsDisplay from './LoginSocialsDisplay'

export {
  LoginSocials,
  LoginSocialsDisplay
}
